/**
 * AimsDocIndex - Landing page for AIMS Data Model Generator documentation.
 */
import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import DocSidebar from "../components/DocSidebar";
import { AIMS_TOC } from "../data/aimsToc";

const BASE_PATH = "/docs/aims-dmg";

export default function AimsDocIndex() {
  return (
    <Layout
      sidebar={
        <DocSidebar
          basePath={BASE_PATH}
          toc={AIMS_TOC}
          backLabel="← AIMS Data Model Generator"
        />
      }
      showSidebar={true}
    >
      <article className="doc-content max-w-4xl">
        <header className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 border-b border-gray-200 dark:border-gray-700 pb-4">
            AIMS Data Model Generator
          </h1>
          <p className="mt-4 text-gray-600 dark:text-gray-400">
            User guide for generating and managing AIMS data models in PostGIS.
          </p>
        </header>

        <div className="prose prose-gray dark:prose-invert max-w-none">
          <p>
            The AIMS Data Model Generator creates and deploys AIMS (Asset Information Management
            System) data models to a target PostGIS database. Use the sidebar to navigate through
            the documentation.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">Quick links</h2>
          <ul>
            <li>
              <Link
                to={`${BASE_PATH}/introduction`}
                className="text-sepm-primary dark:text-sepm-primary-dark hover:underline"
              >
                1 Introduction
              </Link>
            </li>
            <li>
              <Link
                to={`${BASE_PATH}/prerequisites`}
                className="text-sepm-primary dark:text-sepm-primary-dark hover:underline"
              >
                2.1 Prerequisites
              </Link>
            </li>
            <li>
              <Link
                to={`${BASE_PATH}/step1-connection`}
                className="text-sepm-primary dark:text-sepm-primary-dark hover:underline"
              >
                4.1 Step 1 — Server Connection
              </Link>
            </li>
            <li>
              <Link
                to={`${BASE_PATH}/step4-categories`}
                className="text-sepm-primary dark:text-sepm-primary-dark hover:underline"
              >
                4.4 Step 4 — Categories
              </Link>
            </li>
            <li>
              <Link
                to={`${BASE_PATH}/sql-workflow`}
                className="text-sepm-primary dark:text-sepm-primary-dark hover:underline"
              >
                5.2 Generate SQL Workflow
              </Link>
            </li>
            <li>
              <Link
                to={`${BASE_PATH}/connection-issues`}
                className="text-sepm-primary dark:text-sepm-primary-dark hover:underline"
              >
                8.1 Connection Issues
              </Link>
            </li>
          </ul>

          <p className="mt-8 text-sm text-gray-500 dark:text-gray-500">
            © Copyright SEPM. All logos and trademarks are property of their respective owners.
          </p>
        </div>
      </article>
    </Layout>
  );
}
